/**
 * 현장 문서 보관함 모델 — 백엔드 site_documents 테이블/응답과 1:1.
 * 임의 형식 파일(PDF/HWP/DOCX/DWG/XLSX/이미지/ZIP 등)의 메타데이터.
 */

/**
 * 문서 분류. 현장 안에서 문서를 묶어 보기 위한 값으로, 사진(PHOTO_CATEGORIES)과
 * 같은 규약을 쓴다 — 자유 문자열이며 백엔드는 빈 값을 'other' 로 저장한다.
 * 이 목록이 곧 화면의 탭 순서다.
 */
export const DOCUMENT_CATEGORIES = [
  'drawing',
  'contract',
  'report',
  'manual',
  'asbuilt',
  'other',
] as const;
export type DocumentCategory = typeof DOCUMENT_CATEGORIES[number] | string;

export const DOCUMENT_CATEGORY_LABEL: Record<string, string> = {
  drawing: '도면',
  contract: '계약 / 행정',
  report: '보고서',
  manual: '매뉴얼',
  asbuilt: '준공 / 검수',
  other: '기타',
};

/** 카테고리별 1줄 안내 — 업로더가 어디에 넣어야 할지 고민하지 않도록. */
export const DOCUMENT_CATEGORY_HINT: Record<string, string> = {
  drawing: 'CAD 도면, 평면도, 배치도',
  contract: '계약서, 공문, 승인 서류',
  report: '점검·시험 성적서, 진행 보고',
  manual: '장비 매뉴얼, 설정 가이드',
  asbuilt: '준공 도서, 검수 확인서',
  other: '위에 해당하지 않는 파일',
};

/** 목록·필터에서 쓰는 표시용 이름. 알 수 없는 값이면 원문을 그대로 보여준다. */
export const documentCategoryLabel = (category?: string): string => {
  const key = category && category.trim() ? category : 'other';
  return DOCUMENT_CATEGORY_LABEL[key] ?? key;
};

export interface SiteDocument {
  id: number;
  site_project_id: number;
  filename: string;
  original_name: string;
  mime_type: string;
  size_bytes: number;
  description?: string;
  /** 분류. 컬럼 도입 전 문서는 빈 문자열로 올 수 있어 표시 시 'other' 로 취급한다. */
  category?: DocumentCategory;
  /** 값이 있으면 그 공지사항에 딸린 첨부. 없으면 현장 파일 보관함 파일. */
  schedule_id?: number | null;
  /** 업로더(작성자) 스냅샷 — AuthorChip 으로 이름 + 프로필 이미지 표시. */
  created_by_id?: number;
  created_by_name?: string;
  created_at: string;
  updated_at: string;
}
